import React from 'react';
import { Badge, Box } from '@mui/material';

/** iPhone-style unread count chip (red pill, white digits). */
export const navMessageBadgeChipSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 18,
  height: 18,
  px: '5px',
  borderRadius: 9,
  bgcolor: '#FF3B30',
  color: '#fff',
  fontSize: 11,
  fontWeight: 700,
  lineHeight: 1,
  letterSpacing: 0,
  fontVariantNumeric: 'tabular-nums',
  boxShadow: '0 0 0 1.5px rgba(255,255,255,0.35)',
};

export const navMessageBadgeAnchorSx = {
  '& .MuiBadge-badge': {
    ...navMessageBadgeChipSx,
    transform: 'scale(1) translate(40%, -40%)',
    right: 2,
    top: 2,
  },
};

/**
 * Wrap an icon (or other anchor) with an iPhone-style unread badge.
 */
export const NavMessageBadge = ({ count = 0, children, ...badgeProps }) => {
  const value = Number(count) || 0;
  if (value <= 0) return children;
  return (
    <Badge
      badgeContent={value}
      max={99}
      overlap="circular"
      sx={navMessageBadgeAnchorSx}
      componentsProps={{
        badge: {
          'data-testid': 'nav-message-badge',
        },
      }}
      {...badgeProps}
    >
      {children}
    </Badge>
  );
};

/**
 * Standalone chip for text-only nav labels (desktop tabs, drawer rows).
 */
export const NavMessageCountChip = ({ count = 0, sx = {} }) => {
  const value = Number(count) || 0;
  if (value <= 0) return null;
  return (
    <Box
      component="span"
      data-testid="nav-message-badge"
      aria-label={`${value > 99 ? '99+' : value} new messages`}
      sx={{ ...navMessageBadgeChipSx, ...sx }}
    >
      {value > 99 ? '99+' : value}
    </Box>
  );
};

export default NavMessageBadge;
